/*
 * @Author: LZT
 * @Date: 2024-12-11 11:14:08
 * @LastEditors: ITDLCL
 * @Description:
 * @FilePath: \qs\src\main.js
 */
import "@/assets/css/scss/common.scss";
import "@/assets/css/theme/theme.scss";
import "@/assets/css/fonts.css";
import "tcplayer.js/dist/tcplayer.min.css";
import "vant/es/toast/style";
import "vant/lib/index.css";

import { createApp } from "vue";
import pinia from "./stores/index";
import directives from "./utils/directives.js";
import mitt from "mitt"; // 事件总线轻量库
import XEUtils from "xe-utils";
import VXETable from "vxe-table";
import "vxe-table/lib/style.css";
// 直接引入 uni.webview 文件，它会自动挂载到 window.uni
// import "@/utils/uniappH5/uni.webview.1.5.6.js";
// 提供H5向UniApp发送消息 自动挂载到window.postMessageToUniApp  同时提供window.uni
import "./utils/uni-H5/uniappH5-Bridge.js";

const emitter = mitt();
import "amfe-flexible"; // 用于移动端适配的JavaScript库

import App from "./App.vue";
import router from "./router";
const app = createApp(App);

// 注册为全局属性
app.config.globalProperties.$emitter = emitter;

app.use(pinia);
app.use(router);
app.use(directives);
app.use(VXETable);
// 配置 VXETable
VXETable.setConfig({
  size: 'mini',
  zIndex: 999,
  table: { autoResize: true }
});

app.mount("#app");
